/* eslint-disable react/no-deprecated */
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Row as VDSRow, Col as VDSCol, Grid } from '@vds/grids';
import { Input } from '@vds/inputs';
import { Notification } from '@vds/notifications';

import { Body } from '@vds/typography';
import ReqInput from '../../../common/ReqInput/index';
import Button from '../../../common/Button';
import { goToProcessStep } from '../../../../redirection';
import * as validation from '../../../common/validation';
import {
  isPreorder,
  renderElement,
  isDesktop,
  isTablet,
  isMVA,
  isMobile,
  isDesktopResolution,
  debounce,
  checkUnitAvailability,
  setSession,
  isWHW,
  isWHWP2,
  getSession,
} from '../../../common/Helpers/index';
import { nonDesktopQuery, noPadMobileStrict, StyledWrapper } from './shippingStyles';
import { desktopQuery } from '../../../common/styles';
import { store } from '../../../../configureStore';
import AutoComplete from '../../../common/AutoComplete';
import DropdownSelect from '../../../common/DropdownSelect';
import AddressLineErrorMsg from '../AddressLineErrorMsg';

const Col = styled(VDSCol)`
  margin-top: 24px;
  ${({ styles }) => styles}
`;
const Row = styled(VDSRow)`
  @media (min-width: 768px) {
    & > & {
      margin: 0px !important;
      padding: 0px !important;
    }
    & > div:not(&) {
      padding: 0px !important;
      margin-right: 12px !important;
    }
    & > div:last-of-type {
      margin-right: 0px !important;
    }
  }
  &.tabletDevice {
    @media (orientation: portrait) {
      .address1,
      .address2 {
        flex-basis: calc(calc(100% - 12px) / 2);
        max-width: calc(calc(100% - 12px) / 2);
      }
      .zipcode,
      .state {
        flex-basis: calc(calc(100% - 24px) * 0.25);
        max-width: calc(calc(100% - 24px) * 0.25);
      }
      .city {
        flex-basis: calc(calc(100% - 24px) * 0.5);
        max-width: calc(calc(100% - 24px) * 0.5);
      }
    }
  }
  ${noPadMobileStrict}
`;
class ShippingInfoEdit extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      firstName: this.props.shippingDetails?.[0]?.firstName,
      lastName: this.props.shippingDetails?.[0]?.lastName,
      emailId: this.props.shippingDetails?.[0]?.email,
      phoneNumber: this.props.shippingDetails?.[0]?.cbrPhone,
      adress1: this.props.shippingAddressEdit || this.props?.invalidUnitApartmentCase ? this.props.shippingDetails?.[0]?.address?.addressLine1 : '', // this.props.shippingDetails?.[0]?.address?.addressLine1,
      adress2: this.props.shippingAddressEdit || this.props?.invalidUnitApartmentCase ? this.props.shippingDetails?.[0]?.address?.addressLine2 : '', // this.props.shippingDetails?.[0]?.address?.addressLine2,
      city: this.props.shippingAddressEdit || this.props?.invalidUnitApartmentCase ? this.props.shippingDetails?.[0]?.address?.city : '', // this.props.shippingDetails?.[0]?.address?.city,
      zipCode: this.props.shippingAddressEdit || this.props?.invalidUnitApartmentCase ? this.props.shippingDetails?.[0]?.address?.zipCode : '', // this.props.shippingDetails?.[0]?.address?.zipCode,
      state: this.props.shippingAddressEdit || this.props?.invalidUnitApartmentCase ? this.props.shippingDetails?.[0]?.address?.state : '', // this.props.shippingDetails?.[0]?.address?.state,
      showZipcodeError: false,
      showPoBoxError: false,
      isInvalidAddressError: this.props.isInvalidAddressError,
      showError: false,
      address1ErrorText: '',
      address2ErrorText: this.props.invalidUnitApartmentCase ? 'Enter valid Unit appt/unit Number' : '',
      address2Error: !!this.props.invalidUnitApartmentCase,
      enableButton: false,
      disabled: false,
      addressUnit: [],
      appConfigflag: '',
      isPOBoxAddressError: '',
    };
  }

  componentDidMount() {
    // if (this.props.invalidUnitApartmentCase) {
    //   console.log('HELLO');
    // }
    if (this.props.shippingDetails?.[0]?.address?.addressLine1 && this.props.shippingDetails?.[0]?.address?.addressLine1 !== '') {
      const addressLine = `${this.props.shippingDetails?.[0]?.address?.addressLine1} ${this.props.shippingDetails?.[0]?.address?.city} ${this.props.shippingDetails?.[0]?.address?.state} ${this.props.shippingDetails?.[0]?.address?.zipCode}`;
      this.props.fetchAutoFillAddress(addressLine);
      if (window.vzFlags?.isOnlyTypeAhead === 'app') {
        this.props.apiConfigCall();
      }
    }
    if (this.props.appConfigValue === true || window.vzFlags?.isOnlyTypeAhead === 'yes') {
      this.setState({ appConfigflag: 'yes' });
    } else if (window.vzFlags?.isOnlyTypeAhead === 'no') {
      this.setState({ appConfigflag: 'no' });
    } else if (this.props.appConfigValue === false || window.vzFlags?.isOnlyTypeAhead === 'off') {
      this.setState({ appConfigflag: 'off' });
    }
    if (this.state.adress1 !== '' && this.state.adress2 !== '' && this.state.city !== '' && this.state.zipCode !== '' && this.state.state !== '') {
      this.setState({ enableButton: true, disabled: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.marketDetails && nextProps.marketDetails.marketDetails && nextProps.marketDetails.marketDetails) {
      this.setState({
        zipCode: nextProps.marketDetails.marketDetails.zipCode,
        city: nextProps.marketDetails.marketDetails.city,
        state: nextProps.marketDetails.marketDetails.state,
      });
    }
    if (this.props.updateShippingAdressflag !== nextProps.updateShippingAdressflag) {
      this.setState({ isInvalidAddressError: nextProps.isInvalidAddressError });
      if (isPreorder()) {
        this.props.closeAuthModal();
      } else {
        this.props.redirection();
      }
    }
    if (this.props?.addressList?.length !== nextProps?.addressList?.length) {
      this.props.fetchAutoFillAddressUnit(nextProps?.addressList?.[0]?.locusID);
    }
  }

  componentDidUpdate(prevProps) {
    const { availableAddressUnit } = this.props;
    if (this.props.isEmptyAddress && this.props.isPOBoxAddress) {
      this.setState({
        enableButton: false,
        isPOBoxAddressError: `We can’t accept a P.O. box for shipping.`,
      });
    }
    // const validateTypeAhead = window.vzFlags?.isUnitTypeAhead;
    if (this.props.appConfigValue === true || window.vzFlags?.isOnlyTypeAhead === 'yes') {
      this.setState({ appConfigflag: 'yes' });
    } else if (window.vzFlags?.isOnlyTypeAhead === 'no') {
      this.setState({ appConfigflag: 'no' });
    } else if (this.props.appConfigValue === false || window.vzFlags?.isOnlyTypeAhead === 'off') {
      this.setState({ appConfigflag: 'off' });
    }
    if (prevProps.availableAddressUnit !== availableAddressUnit) {
      const listItems = [];
      if (Number(availableAddressUnit?.totalHits) >= 1 && Number(availableAddressUnit?.totalHits) <= 10 && availableAddressUnit?.data) {
        availableAddressUnit.data.map((unitList) => listItems.push({ key: unitList.sublocation, value: unitList.sublocation }));
        if (Number(availableAddressUnit?.totalHits) === 1) {
          listItems.push({ key: 'NA', value: "I don't live in a unit" });
          listItems.push({ key: 'NA', value: "I can't find my unit" });
        }
      } else if (Number(availableAddressUnit?.totalHits) > 10) {
        availableAddressUnit.data.map((unitList) => listItems.push({ key: unitList.sublocation, value: unitList.sublocation }));
      }
      if (availableAddressUnit?.totalHits !== undefined) {
        this.props.shippingAddress2unitItems(Number(availableAddressUnit?.totalHits));
        if (listItems?.length > 0) {
          this.props.shippingAddress2unitArray(listItems);
        }
      }
      this.setState({ addressUnit: listItems });
    }
    if (this.state.appConfigflag === 'no' && this.props.availableAddressUnit && Number(this.props.availableAddressUnit?.totalHits) >= 0) {
      if (
        this.props.availableAddressUnit?.totalHits &&
        Number(this.props.availableAddressUnit?.totalHits) > 0 &&
        this.props.availableAddressUnit?.data &&
        !this.state.adress2
      ) {
        this.setState({ disabled: true });
      } else {
        this.setState({ disabled: false });
      }
    }
  }

  componentWillUnmount() {
    renderElement(null, 'shippingInfoEditCTA');
  }

  redirect = (notifyMessage) => {
    const listOfUnits = this.props?.unitlist?.map((obj) => obj.sublocation);
    let Adress2locusApi = '';
    if ((window.vzFlags?.isOnlyTypeAhead === 'app' && this.props.appConfigValue === true) || window.vzFlags?.isOnlyTypeAhead === 'yes') {
      if (listOfUnits?.includes(this.state.adress2) || this.state.adress2) {
        Adress2locusApi = this.state.adress2;
      } else {
        Adress2locusApi = '';
      }
    } else {
      Adress2locusApi = this.state.adress2;
    }
    const data = {
      adress1: this.state.adress1,
      adress2: Adress2locusApi,
      city: this.state.city,
      zipCode: this.state.zipCode,
      state: this.state.state,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      emailId: this.state.emailId,
      phoneNumber: this.state.phoneNumber,
      isFwaServiceAddress: false,
    };
    if (notifyMessage) {
      data.notifyMessage = notifyMessage;
    }
    let homePhoneAdded = false;
    const homePhoneResponse = this.props.cartDetails?.dueTodayList?.filter((item) => item.isHomePhone !== undefined && item.isHomePhone === true);
    if (homePhoneResponse.length > 0) {
      homePhoneAdded = true;
    }
    data.homePhoneAdded = homePhoneAdded;
    if (this.props?.clickUpdateShippingAddress) {
      this.props.clickUpdateShippingAddress(data, homePhoneAdded);
    } else {
      this.props.updateShippingAddress(data, homePhoneAdded);
    }
  };

  onChangeTextBox = (name, e) => {
    if (this.props.appConfigValue === true || window.vzFlags?.isOnlyTypeAhead === 'yes') {
      this.setState({ appConfigflag: 'yes' });
    } else if (window.vzFlags?.isOnlyTypeAhead === 'no') {
      this.setState({ appConfigflag: 'no' });
    } else if (this.props.appConfigValue === false || window.vzFlags?.isOnlyTypeAhead === 'off') {
      this.setState({ appConfigflag: 'off' });
    }
    this.setState({ showError: false, isInvalidAddressError: false });
    const { id, value } = e.target;
    let { showZipcodeError } = this.state;
    if (id === 'zipCode') {
      showZipcodeError = validation.isValidZipCode(value);
      if (value.length === 5) {
        this.props.getZipDetailsFromApi(value);
      }
      this.setState({
        [name]: value,
        showZipcodeError: !showZipcodeError,
      });
    } else if (id === 'adress1') {
      if (value?.trim()?.length > 0) {
        const fetchAdress = () => this.props.fetchAutoFillAddress(value);
        // this.props.fetchAutoFillAddress(value);
        debounce(fetchAdress, value, 3000);
        const isPOBoxAddress = validation?.isPoBoxAddress(value);

        this.setState({
          address1ErrorText: '',
          isPOBoxAddressError: isPOBoxAddress ? `We can’t accept a P.O. box for shipping.` : '',
          enableButton: !isPOBoxAddress,
          disabled: false,
        });
      } else {
        store.dispatch({ type: 'FETCH_AUTOFILL_ADDRESS_SUCCESS', apiResponse: {} });
        const address1ErrorText = 'Please enter a valid Shipping Address 1';
        this.setState({ address1ErrorText, isPOBoxAddressError: '', enableButton: false });
      }
      this.setState({
        [name]: value,
      });
    } else if (id === 'adress2' || name === 'address2') {
      // debugger;
      if (this.state?.appConfigflag === 'yes' || this.state?.appConfigflag === 'no') {
        // debugger;
        if (value?.trim()?.length > 0) {
          store.dispatch({ type: 'FETCH_AUTOFILL_ADDRESS_UNIT_SUCCESS2', apiResponse: {} });
          const fetchAdress = () => this.props.fetchAutoFillAddressUnit2(value, getSession('locationId') || this.props?.addressList?.[0]?.locusID);
          debounce(fetchAdress, value, 3000);
          this.setState({ address2ErrorText: '', address2Error: false, enableButton: true, disabled: false });
        } else {
          const address2ErrorText = 'This is a mandatory field.';
          this.setState({ address2ErrorText, address2Error: true, enableButton: false });
        }
        this.setState({
          [name]: value,
        });
      } else if (value === "I don't live in a unit" || value === "I can't find my unit") {
        this.setState({
          [name]: 'NA',
          showZipcodeError: false,
        });
      } else {
        this.setState({
          [name]: value,
          showZipcodeError: false,
        });
      }
    } else {
      this.setState({
        [name]: value,
        showZipcodeError: false,
      });
    }
  };

  checkForButtonEnableCondition = () => this.state.enableButton;

  ShippingInfoEditCTA = () => (
    <StyledWrapper styles={`margin-top: 20px; ${nonDesktopQuery('margin-top: 48px')}`}>
      <Button
        className="newShippingAddressCTA"
        primary
        disabled={
          !!this.state.showZipcodeError ||
          !!this.state.showPoBoxError ||
          !this.checkForButtonEnableCondition() ||
          this.state.isInvalidAddressError ||
          this.state.showError ||
          this.state.disabled ||
          (this.props.shippingInfoDetails?.lines?.[0] &&
            this.props.shippingInfoDetails?.lines?.[0]?.shippingOptions &&
            isEmpty(this.props.shippingInfoDetails?.lines?.[0]?.shippingOptions))
        }
        // disabled= {this.state.disabled}
        onClick={() => this.redirect(this.props.notifyMessage)}
        data-track="true"
        width={isTablet() && !isDesktopResolution() ? '383px' : '100%'}
      >
        {isPreorder() ? 'Submit' : 'Continue'}
      </Button>
    </StyledWrapper>
  );

  onUnitSelection = (e) => {
    const unitSelected = this.props?.unitlist?.filter((item) => item?.sublocation === e);
    this.setState({
      adress2: unitSelected?.[0]?.sublocation,
    });
  };

  onAddressSelection = (e) => {
    const { fetchAutoFillAddressUnit } = this.props;
    const addressSelected = this.props.addressList.filter((item) => item.disprawstr === e);
    const selectedAddress = addressSelected?.[0];
    const isPOBoxAddress = validation?.isPoBoxAddress(selectedAddress?.disprawstr);
    // console.log('selectionFromAutoFill', selectedAddress);
    const { locusID } = selectedAddress;
    this.setState({
      adress1: selectedAddress?.dispstr,
      zipCode: selectedAddress?.zip,
      state: selectedAddress?.state,
      city: selectedAddress?.muni,
      enableButton: !isPOBoxAddress,
      disabled: false,
      adress2: '',
      isPOBoxAddressError: isPOBoxAddress ? `We can’t accept a P.O. box for shipping.` : '',
    });
    setSession('locationId', locusID);
    if (this.state?.appConfigflag === 'no') {
      setSession('locationId', locusID);
      fetchAutoFillAddressUnit(locusID);
    }
  };

  checkUnit = (id) => {
    const { availableAddressUnit } = this.props;
    const { adress2 } = this.state;
    const unit = checkUnitAvailability(id, adress2, availableAddressUnit);
    this.setState({ adress2: unit });
  };

  render() {
    const { pageName, marketDetails, paymentZipcodeError, showBtnOnly, notifyMessage, isInvalidAddressError } = this.props;
    const { addressUnit } = this.state;
    if (marketDetails && marketDetails.errorMessage) {
      this.setState({ showError: true });
    } else if (marketDetails && !marketDetails.errorMessage) {
      this.setState({ showError: false });
    }
    if (this.props.shippingInfoState?.paymentSkipCall && this.props.orderDetails.dueTodayAmount > 0 && this.props.paymentInfoState) {
      if (this.props.isBTAAvailable && this.props.isBTAAvailable.length > 0) {
        const isBTA = this.props.isBTAAvailable[0];
        const data = {
          isBTA,
        };
        store.dispatch({ type: 'IS_BTA_ELIGIBLE', value: true });
        store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: false });
        this.props.confirmSubmit(data);
      } else if (this.props.otherPaymentOptions && this.props.otherPaymentOptions.length > 0) {
        store.dispatch({ type: 'PAYMENT_SKIP_CALL', value: false });
        const updateView = this.props.currentView.Payment;
        goToProcessStep(updateView, this.props.history);
      }
    }
    return (
      <React.Fragment>
        <Grid>
          {!this.props.invalidUnitApartmentCase &&
          this.props?.lvShippingAddressTitle &&
          this.props?.lvShippingAddressTitle.length !== 0 &&
          this.props?.lvShippingAddressSubtitle &&
          this.props?.lvShippingAddressSubtitle.length !== 0 &&
          !(isWHW() || isWHWP2()) ? (
            <Row>
              <Notification
                className={isMobile() ? 'marginTop10' : 'marginTop20 '}
                type="warning"
                title={this.props?.lvShippingAddressTitle}
                subtitle={this.props?.lvShippingAddressSubtitle}
              />
            </Row>
          ) : (
            <></>
          )}
          <Row className={`paymentError ${isTablet() ? 'tabletDevice' : ''}`}>
            <Col
              disabled
              className="address1"
              colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}
              styles={desktopQuery('flex-basis: 398px; max-width: 398px;')}
            >
              {
                <>
                  {!this.props.invalidUnitApartmentCase && <Body primitive="p">Shipping Address 1* (No P.O box number)</Body>}
                  {!this.props.invalidUnitApartmentCase ? (
                    <>
                      {' '}
                      <AutoComplete
                        disabled
                        typedValue={this.state.adress1}
                        value={this.state.adress1}
                        onSelect={(e) => this.onAddressSelection(e)}
                        items={this.props.addressList}
                        onChange={
                          this.props.invalidUnitApartmentCase
                            ? () => {
                                console.log('HELLO');
                              }
                            : (e) => this.onChangeTextBox('adress1', e)
                        }
                        isDisabled={this.props.invalidUnitApartmentCase}
                        inputProps={{
                          className: `autocompleteInput address-autocomplete contactInput36 ${
                            this.state.address1ErrorText?.trim()?.length > 0 || this.state?.isPOBoxAddressError ? 'errorBg' : ''
                          }`,
                          // }
                          'aria-label': 'Address Option 1',
                          'aria-controls': 'Addressoptions',
                          id: 'adress1',
                          name: 'adress1',
                          itemval: 'disprawstr',
                          itemkey: ['locusID', 'muni'],
                        }}
                        width={isMobile() && pageName === 'orderreview' ? '311px' : ''}
                      />
                      <AddressLineErrorMsg
                        addressLine={this.state?.adress1}
                        isEmptyAddress={this.props.isEmptyAddress}
                        addressLineError={this.state.address1ErrorText}
                      />
                    </>
                  ) : (
                    <>
                      <Input
                        id="adress1"
                        name="adress1"
                        type="text"
                        placeholder=""
                        // required={false}
                        className="contactInput36"
                        label="Shipping Address 1* (No P.O box number)"
                        disabled
                        value={this.state.adress1}
                        defaultValue={this.state.adress1}
                      />{' '}
                    </>
                  )}
                </>
              }
            </Col>
            <Col className="address2" colSizes={{ mobile: 4, tablet: 6, desktop: 6 }} styles={desktopQuery('flex-basis: 398px; max-width: 398px;')}>
              {this.state?.appConfigflag === 'no' ? (
                this.state.adress1 && this.props.shippingAddress2UnitCount > 0 ? (
                  this.props.shippingAddress2UnitCount < 10 ? (
                    <DropdownSelect
                      topLabelText={this.props?.invalidUnitApartmentCase ? 'Apartment/Unit Number' : 'Shipping Address 2 (Apartment/Unit)'}
                      options={addressUnit}
                      id="adress2"
                      name="adress2"
                      className="contactInput36"
                      label={this.state.adress2 !== '' ? this.state.adress2 : '   '}
                      ariaLabel="Shipping Address 2 Input Fields"
                      // required={this.props.shippingAddress2UnitCount > 0}
                      required
                      handleChangeEvent={(e) => this.onChangeTextBox('adress2', e)}
                      error={this.state.address2Error}
                      errorText={this.state.address2ErrorText}
                      data-cs-mask
                    />
                  ) : (
                    <>
                      <Body primitive="p">
                        {this.props?.invalidUnitApartmentCase ? 'Apartment/Unit Number' : 'Shipping Address 2 (Apartment/Unit)'}
                      </Body>
                      <AutoComplete
                        id="adress2"
                        typedValue={this.state.adress2}
                        value={this.state.adress2}
                        onSelect={(e) => this.onUnitSelection(e)}
                        items={this.props?.unitlist}
                        onChange={(e) => this.onChangeTextBox('adress2', e)}
                        inputProps={{
                          className: `autocompleteInput address-autocomplete contactInput36 ${this.state.address2ErrorText ? 'errorBg' : ''}`,
                          'aria-label': 'Address Option 2',
                          'aria-controls': 'Addressoptions',
                          id: 'adress2',
                          name: 'adress2',
                          itemval: 'sublocation',
                          itemkey: ['locusID', 'sublocation1'],
                        }}
                        width={isMobile() && pageName === 'orderreview' ? '311px' : ''}
                      />
                      {this.state.address2ErrorText && this.state.address2ErrorText !== '' && (
                        <Body primitive="p">{this.state.address2ErrorText}</Body>
                      )}
                    </>
                  )
                ) : (
                  <Input
                    id="adress2"
                    name="adress2"
                    type="text"
                    placeholder=""
                    required={false}
                    className="contactInput36"
                    label="Shipping Address 2"
                    onChange={(e) => this.onChangeTextBox('adress2', e)}
                    width={isMobile() && pageName === 'orderreview' ? '311px' : ''}
                  />
                )
              ) : this.state?.appConfigflag === 'yes' ? (
                <>
                  <Body primitive="p">
                    Shipping Address 2 <span className="color_optional">Optionsal</span>
                  </Body>
                  <AutoComplete
                    typedValue={this.state.adress2}
                    id="adress2"
                    value={this.state.adress2}
                    onSelect={(e) => this.onUnitSelection(e)}
                    items={this.props?.unitlist}
                    onChange={(e) => this.onChangeTextBox('adress2', e)}
                    inputProps={{
                      className: `autocompleteInput address-autocomplete contactInput36`,
                      // }
                      'aria-label': 'Address Option 2',
                      'aria-controls': 'Addressoptions',
                      id: 'adress2',
                      name: 'adress2',
                      itemval: 'sublocation',
                      itemkey: ['locusID', 'sublocation1'],
                    }}
                    width={isMobile() && pageName === 'orderreview' ? '311px' : ''}
                  />
                </>
              ) : (
                <Input
                  id="adress2"
                  name="adress2"
                  type="text"
                  placeholder=""
                  required={false}
                  className="contactInput36"
                  label="Shipping Address 2"
                  ariaLabel="Billing Address 2 Input Fields"
                  onChange={(e) => this.onChangeTextBox('adress2', e)}
                  onBlur={(e) => this.checkUnit('address2', e)}
                  disabled={this.props.invalidUnitApartmentCase}
                  width={isMobile() && pageName === 'orderreview' ? '311px' : ''}
                />
              )}
            </Col>
          </Row>
          <Row className={`InlineAddress ${isTablet() ? 'tabletDevice' : ''}`}>
            <Col
              className="zipcode"
              colSizes={isMobile() && pageName === 'orderreview' ? { tablet: 3, desktop: 3 } : { mobile: 4, tablet: 3, desktop: 3 }}
              styles={desktopQuery('flex-basis: 188px; max-width: 188px;')}
            >
              <ReqInput
                defaultValue={this.props.shippingDetails?.[0]?.address?.zipCode}
                id="zipCode"
                name="zipCode"
                type="number"
                placeholder=""
                isDisabled={this.props.invalidUnitApartmentCase}
                className="contactInput36"
                maxLength={5}
                label={<Body primitive="span">Zip Code*</Body>}
                onChange={(e) => {
                  if (e.target.value.length <= 5) {
                    this.onChangeTextBox('zipCode', e);
                  }
                }}
                value={this.state.zipCode}
                error={this.state.showZipcodeError}
                errorText={this.state.showZipcodeError ? paymentZipcodeError : false}
                width={isMobile() && pageName === 'orderreview' ? '97px' : ''}
              />
            </Col>
            <Col
              className="city"
              colSizes={isMobile() && pageName === 'orderreview' ? { tablet: 3, desktop: 3 } : { mobile: 4, tablet: 3, desktop: 3 }}
              styles={desktopQuery('flex-basis: 408px; max-width: 408px;')}
            >
              <ReqInput
                defaultValue={this.props.shippingDetails?.[0]?.address?.city}
                id="city"
                name="city"
                type="text"
                placeholder=""
                isDisabled={!!this.props.invalidUnitApartmentCase}
                className="contactInput36"
                required
                label={<Body primitive="span">City*</Body>}
                onChange={(e) => this.onChangeTextBox('city', e)}
                value={this.state.city}
                width={isMobile() && pageName === 'orderreview' ? '97px' : ''}
              />
            </Col>
            <Col
              className="state"
              colSizes={isMobile() && pageName === 'orderreview' ? { tablet: 3, desktop: 3 } : { mobile: 4, tablet: 3, desktop: 3 }}
              styles={desktopQuery('flex-basis: 188px; max-width: 188px;')}
            >
              <ReqInput
                defaultValue={this.props.shippingDetails?.[0]?.address?.state}
                id="state"
                name="state"
                type="text"
                placeholder=""
                className="contactInput36"
                isDisabled={!!this.props.invalidUnitApartmentCase}
                required
                // isDisabled
                label={<Body primitive="span">State</Body>}
                onChange={(e) => this.onChangeTextBox('state', e)}
                value={this.state.state}
                width={isMobile() && pageName === 'orderreview' ? '97px' : ''}
              />
            </Col>
          </Row>
          <Row className={isMobile() && pageName === 'orderreview' ? 'ModalButton' : ''}>
            <Col colSizes={{ mobile: 4 }}>
              {!showBtnOnly && (
                <>
                  {isDesktop() || (isTablet() && isDesktopResolution()) ? (
                    renderElement(<this.ShippingInfoEditCTA />, 'shippingInfoEditCTA', true)
                  ) : (
                    <this.ShippingInfoEditCTA />
                  )}
                </>
              )}
              {showBtnOnly && (
                <Button
                  className="marginLeft10 margin30 onlyTopMargin shipButton"
                  primary
                  disabled={
                    !!this.state.showZipcodeError ||
                    !!this.state.showPoBoxError ||
                    !this.state.adress1 ||
                    isInvalidAddressError ||
                    this.state.showError
                  }
                  onClick={() => this.redirect(notifyMessage)}
                  data-track="true"
                  width={isMobile() || isMVA() ? '100%' : '160px'}
                >
                  Submit
                </Button>
              )}
            </Col>
          </Row>
        </Grid>
      </React.Fragment>
    );
  }
}
ShippingInfoEdit.propTypes = {
  currentView: PropTypes.object,
  orderDetails: PropTypes.object,
  history: PropTypes.object,
  updateShippingAddress: PropTypes.func,
  shippingDetails: PropTypes.object,
  marketDetails: PropTypes.object,
  getZipDetailsFromApi: PropTypes.func,
  notifyMessage: PropTypes.string,
  updateShippingAdressflag: PropTypes.bool,
  cartDetails: PropTypes.object,
  isInvalidAddressError: PropTypes.bool,
  closeAuthModal: PropTypes.any,
  unitlist: PropTypes.any,
  appConfigValue: PropTypes.any,
  clickUpdateShippingAddress: PropTypes.any,
  paymentZipcodeError: PropTypes.string,
  showBtnOnly: PropTypes.bool,
  confirmSubmit: PropTypes.func,
  otherPaymentOptions: PropTypes.array,
  pageName: PropTypes.string,
  shippingInfoState: PropTypes.object,
  paymentSkipCall: PropTypes.bool,
  paymentInfoState: PropTypes.object,
  isBTAAvailable: PropTypes.array,
  addressList: PropTypes.any,
  fetchAutoFillAddressUnit2: PropTypes.func,
  apiConfigCall: PropTypes.func,
  fetchAutoFillAddress: PropTypes.func,
  // shippingAddressErrorMessage: PropTypes.string,
  lvShippingAddressTitle: PropTypes.string,
  lvShippingAddressSubtitle: PropTypes.string,
  isEmptyAddress: PropTypes.bool,
  isPOBoxAddress: PropTypes.bool,
  redirection: PropTypes.func,
  shippingInfoDetails: PropTypes.object,
  fetchAutoFillAddressUnit: PropTypes.func.isRequired,
  availableAddressUnit: PropTypes.array.isRequired,
  shippingAddress2unitArray: PropTypes.func,
  shippingAddress2unitItems: PropTypes.func,
  shippingAddress2UnitCount: PropTypes.number,
  shippingAddressEdit: PropTypes.bool,
  invalidUnitApartmentCase: PropTypes.bool,
};
export default withRouter(ShippingInfoEdit);
